import { gql } from '@apollo/client';
import { EntityReminderFragment } from '../fragments/EntityReminderFragment';
/**
 * @const CreateEntityReminderMutation
 * @since 1.0.0
 */
export const CreateEntityReminderMutation = gql `
  mutation CreateEntityReminderMutation($input: CreateEntityReminderInput!) {
    createEntityReminder(input: $input) {
      ...EntityReminderFragment
    }
  }

  ${EntityReminderFragment}
`;
